// extracted by mini-css-extract-plugin
export default {"page":"about_page__Le8af","title":"about_title__WGyN7","text":"about_text__TtTX4","link":"about_link__GuQxM","divider":"about_divider__Yjxjw"};